
/*
  UXS REPLY V5 — UNIDOS X EL SONIDO
  Integra Incoming V7, Transcription V3, MP3 V1, Share V8.
  Conecta las tres salidas del flujo al Outro V23.
  Conserva intactos el guardado, la transcripción y el vocoder.
  No modifica el vocoder, los subtítulos ni la transcripción.
  Las respuestas se guardan pendientes de moderación.
*/
(function () {
  "use strict";

  const SUPABASE_URL = "https://owwcdrqwfevwbkubrlff.supabase.co";
  const SUPABASE_KEY = "sb_publishable_xn5hzUtHdOZNJZ0eRZLr_g_3SmeqUS4";

  function init() {
    const root = document.getElementById("uxs-experience");
    const recording = document.getElementById("uxs-recording");
    const record = document.getElementById("uxs-record");
    const results = document.getElementById("uxs-results");
    if (!root || !recording || !record || !results || root.dataset.replyUiReady) return;
    root.dataset.replyUiReady = "v5";

    document.getElementById("uxs-reply-styles")?.remove();
    const style = document.createElement("style");
    style.id = "uxs-reply-styles";
    style.textContent = `
      #uxs-reply-choice, #uxs-reply-composer, #uxs-reply-end,
      #uxs-reply-context { display:none; }
      #uxs-reply-choice, #uxs-reply-composer, #uxs-reply-end {
        width:min(90vw,420px); max-width:100%; margin:18px auto 0;
        flex-direction:column; align-items:center; gap:15px;
        color:#fff; font-family:monospace; text-align:center;
      }
      #uxs-reply-choice.uxs-visible { display:flex; animation:uxs-reply-enter .65s ease both; }
      #uxs-reply-choice h2, #uxs-reply-composer h2, #uxs-reply-end h2 {
        margin:0; color:#fff; font:400 clamp(14px,2.7vw,18px)/1.7 monospace;
        letter-spacing:1.7px;
      }
      #uxs-reply-choice button, #uxs-reply-composer button, #uxs-reply-end button {
        appearance:none; min-width:195px; min-height:47px; padding:12px 23px;
        border:1px solid rgba(255,255,255,.5); border-radius:999px;
        background:transparent; color:#fff; font:11px/1.6 monospace;
        letter-spacing:1.3px; cursor:pointer; transition:background .25s,border-color .25s;
      }
      #uxs-reply-choice button:hover, #uxs-reply-composer button:hover, #uxs-reply-end button:hover {
        border-color:#fff; background:rgba(255,255,255,.07);
      }
      #uxs-reply-choice button:disabled, #uxs-reply-composer button:disabled {
        opacity:.4; cursor:wait;
      }
      #uxs-reply-skip, #uxs-reply-cancel { border-color:transparent !important; opacity:.7; }
      #uxs-reply-context { width:min(88vw,410px); margin:0 auto 12px; text-align:center; }
      .uxs-reply-kicker { color:rgba(255,255,255,.4); font:9px/1.7 monospace; letter-spacing:2px; }
      .uxs-reply-question { margin-top:8px; color:rgba(255,255,255,.76); font:11px/1.85 monospace; letter-spacing:.5px; overflow-wrap:anywhere; }
      #uxs-reply-composer .uxs-reply-description, #uxs-reply-end p {
        color:rgba(255,255,255,.56); font:10px/1.9 monospace;
        letter-spacing:.7px; margin:0; max-width:355px;
      }
      #uxs-reply-composer .uxs-reply-actions { display:flex; flex-direction:column; gap:9px; align-items:center; }
      #uxs-reply-composer .uxs-reply-privacy {
        color:rgba(255,255,255,.4); font:9px/1.8 monospace;
        max-width:365px; margin:0;
      }
      #uxs-reply-feedback { min-height:19px; color:rgba(255,255,255,.65); font:10px/1.9 monospace; letter-spacing:.5px; }
      #uxs-experience.uxs-reply-mode #uxs-share-panel,
      #uxs-experience.uxs-reply-mode #uxs-first-question-subtitle,
      #uxs-experience.uxs-reply-mode #uxs-recording-question,
      #uxs-experience.uxs-reply-mode #uxs-your-question,
      #uxs-experience.uxs-reply-mode #uxs-share-rejection-question {
        display:none !important;
      }
      #uxs-experience.uxs-reply-mode #uxs-reply-context { display:block; }
      #uxs-experience.uxs-reply-mode #uxs-incoming-panel { display:none !important; }
      #uxs-experience.uxs-reply-mode #uxs-main {
        display:flex !important; flex-direction:column; align-items:center !important;
        justify-content:center !important; opacity:1 !important; visibility:visible !important;
        min-height:100svh; height:auto; padding:25px 16px !important;
      }
      #uxs-experience.uxs-reply-mode #uxs-recording {
        display:flex !important; flex-direction:column; align-items:center;
        width:min(90vw,600px); margin:0 auto !important;
      }
      #uxs-experience.uxs-reply-mode.uxs-reply-recording #uxs-record,
      #uxs-experience.uxs-reply-mode.uxs-reply-recording #uxs-status { display:block !important; }
      #uxs-experience.uxs-reply-mode.uxs-audio-ready #uxs-reply-context,
      #uxs-experience.uxs-reply-mode.uxs-reply-recording #uxs-reply-context {
        display:block !important;
      }
      #uxs-experience.uxs-reply-mode.uxs-audio-ready #uxs-audio-interface {
        display:flex !important;
      }
      #uxs-experience.uxs-reply-mode.uxs-reply-composing #uxs-reply-composer {
        display:flex; animation:uxs-reply-enter .6s ease both;
      }
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-reply-end {
        display:flex; animation:uxs-reply-enter .6s ease both;
      }
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-audio-interface,
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-transcription-panel,
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-record,
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-status,
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-record-timer,
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-reply-context {
        display:none !important;
      }
      /* Las dos etapas también aplican a la primera señal. */
      #uxs-experience[data-uxs-review-step="sound"] #uxs-transcription-panel { display:none !important; }
      #uxs-experience[data-uxs-review-step="transcript"] #uxs-audio-interface { display:none !important; }
      #uxs-experience[data-uxs-review-step="confirmed"] #uxs-audio-interface,
      #uxs-experience[data-uxs-review-step="confirmed"] #uxs-transcription-panel { display:none !important; }
      #uxs-review-continue { display:none; appearance:none; border:1px solid white;
        background:white; color:#050505; border-radius:999px; min-width:195px;
        padding:13px 26px; font:11px monospace; letter-spacing:1.5px;
        margin:4px auto 0; cursor:pointer; }
      #uxs-experience[data-uxs-review-step="sound"] #uxs-audio-interface.uxs-visible #uxs-review-continue { display:block !important; }
      #uxs-experience[data-uxs-review-step="transcript"] #uxs-transcription-panel.uxs-visible {
        display:flex !important; margin:8px auto 0; max-width:min(90vw,420px); gap:12px; }
      #uxs-experience[data-uxs-review-step="transcript"] #uxs-t-text {
        min-height:100px; max-height:25svh; }
      #uxs-review-back-sound, #uxs-reply-back-transcript,
      #uxs-share-back-transcript {
        appearance:none; display:block; min-height:42px; margin:10px auto 0;
        padding:10px 22px; border:1px solid rgba(255,255,255,.35);
        border-radius:999px; background:transparent; color:rgba(255,255,255,.8);
        font:10px/1.6 monospace; letter-spacing:1.2px; cursor:pointer;
      }
      #uxs-experience[data-uxs-review-step="transcript"]
      #uxs-review-back-sound { display:block; }
      #uxs-experience:not([data-uxs-review-step="transcript"])
      #uxs-review-back-sound { display:none; }
      #uxs-reply-composer #uxs-reply-back-transcript {
        min-width:150px; border-color:rgba(255,255,255,.35) !important;
      }
      /* Si regresamos desde compartir, ocultar esa decisión hasta confirmar de nuevo. */
      #uxs-experience[data-uxs-review-step="transcript"] #uxs-share-panel {
        display:none !important;
      }
      /* Mismas proporciones y jerarquía que la primera señal. */
      #uxs-experience.uxs-reply-choice-stage #uxs-main {
        display:flex !important; opacity:1 !important; visibility:visible !important;
        flex-direction:column; align-items:center; justify-content:center !important;
        height:100svh; min-height:100svh; overflow-y:auto; gap:8px;
        padding:20px 15px !important;
      }
      #uxs-experience.uxs-reply-choice-stage #uxs-recording {
        display:flex !important; flex-direction:column; align-items:center;
        width:min(90vw,440px); margin:0 auto !important;
      }
      #uxs-experience.uxs-reply-choice-stage #uxs-incoming-panel,
      #uxs-experience.uxs-reply-choice-stage #uxs-message,
      #uxs-experience.uxs-reply-choice-stage #uxs-record,
      #uxs-experience.uxs-reply-choice-stage #uxs-status,
      #uxs-experience.uxs-reply-choice-stage #uxs-transcript,
      #uxs-experience.uxs-reply-choice-stage #uxs-audio-interface,
      #uxs-experience.uxs-reply-choice-stage #uxs-transcription-panel,
      #uxs-experience.uxs-reply-choice-stage #uxs-share-panel,
      #uxs-experience.uxs-reply-choice-stage #uxs-record-privacy,
      #uxs-experience.uxs-reply-choice-stage #uxs-recording-question {
        display:none !important;
      }
      #uxs-experience.uxs-reply-choice-stage #uxs-reply-choice {
        display:flex !important; margin:4px auto 0; gap:12px;
      }
      .uxs-reply-overline { margin:0; color:rgba(255,255,255,.46);
        font:9px/1.7 monospace; letter-spacing:1.8px; }
      .uxs-reply-anon { margin:0 0 9px; max-width:290px;
        color:rgba(255,255,255,.64); font:10px/1.8 monospace; letter-spacing:.5px; }
      #uxs-experience.uxs-reply-mode #uxs-main {
        height:100svh; overflow-y:auto; gap:9px !important;
      }
      #uxs-experience.uxs-reply-mode #uxs-visualizer,
      #uxs-experience.uxs-reply-choice-stage #uxs-visualizer {
        width:min(55vw,235px,30svh) !important;
        height:auto !important; max-width:none;
        margin:0 auto 8px !important;
      }
      #uxs-experience.uxs-reply-mode #uxs-recording {
        gap:10px !important; margin:0 auto !important;
      }
      #uxs-experience.uxs-reply-mode #uxs-reply-context {
        display:none !important;
      }
      #uxs-experience.uxs-reply-mode.uxs-reply-recording #uxs-reply-context {
        display:block !important; margin-bottom:8px;
      }
      #uxs-experience.uxs-reply-mode #uxs-record-privacy,
      #uxs-experience.uxs-reply-mode #uxs-transcript,
      #uxs-experience.uxs-reply-mode #uxs-message,
      #uxs-experience.uxs-reply-mode #uxs-share-panel {
        display:none !important;
      }
      #uxs-experience.uxs-reply-mode[data-uxs-review-step="sound"] #uxs-transcription-panel {
        display:none !important;
      }
      #uxs-experience.uxs-reply-mode[data-uxs-review-step="transcript"] #uxs-audio-interface,
      #uxs-experience.uxs-reply-mode[data-uxs-review-step="confirmed"] #uxs-audio-interface,
      #uxs-experience.uxs-reply-mode[data-uxs-review-step="confirmed"] #uxs-transcription-panel {
        display:none !important;
      }
      #uxs-experience.uxs-reply-mode.uxs-reply-composing #uxs-reply-composer {
        display:flex !important;
        margin:3px auto 0; gap:15px; width:min(90vw,400px);
      }
      #uxs-experience.uxs-reply-mode.uxs-reply-composing #uxs-reply-context,
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-reply-context {
        display:none !important;
      }
      #uxs-experience.uxs-reply-mode.uxs-reply-finished #uxs-reply-end {
        margin:0 auto; gap:15px;
      }
      /* En público: ocultar TODO el texto técnico del outro. */
      body:not(.uxs-outro-test-mode) #uxs-outro-v23 .state {
        display:none !important;
      }
      /* Controles de desarrollo solamente visibles con ?uxs_outro_test=1 */
      body:not(.uxs-outro-test-mode) #uxs-outro-v23 .ctrl,
      body:not(.uxs-outro-test-mode) #uxs-outro-v23 .ctrl ~ div {
        display:none !important;
      }
      #uxs-outro-public-play {
        display:none; position:absolute; left:50%; bottom:clamp(40px,9vh,100px);
        transform:translateX(-50%); z-index:3;
        padding:13px 30px; border:1px solid rgba(255,255,255,.7);
        background:#050505; border-radius:40px; color:white;
        font:11px monospace; letter-spacing:2px; cursor:pointer;
      }
      #uxs-outro-public-play.uxs-visible { display:block; }
      #uxs-incoming-human-note {
        color:rgba(255,255,255,.62); text-align:center;
        font:10px/1.8 monospace; letter-spacing:1px;
        max-width:min(86vw,440px); margin:0 auto 12px;
      }
      @media(max-width:600px) {
        #uxs-experience.uxs-reply-mode #uxs-main,
        #uxs-experience.uxs-reply-choice-stage #uxs-main {
          padding:14px 12px 22px !important;
        }
        #uxs-experience.uxs-reply-mode #uxs-visualizer,
        #uxs-experience.uxs-reply-choice-stage #uxs-visualizer {
          width:min(48vw,205px,25svh) !important; margin-bottom:4px !important;
        }
        #uxs-experience.uxs-reply-mode #uxs-audio-interface,
        #uxs-experience.uxs-reply-mode #uxs-transcription-panel {
          margin:5px auto 0 !important; gap:11px;
        }
      }
      @keyframes uxs-reply-enter { from {opacity:0;transform:translateY(12px)} to {opacity:1;transform:translateY(0)} }
      @media(prefers-reduced-motion:reduce) { #uxs-reply-choice.uxs-visible {animation:none;} }
    `;
    document.head.appendChild(style);

    ["uxs-reply-choice", "uxs-reply-context", "uxs-reply-composer", "uxs-reply-end"]
      .forEach(id => document.getElementById(id)?.remove());

    const choice = document.createElement("div");
    choice.id = "uxs-reply-choice";
    choice.innerHTML = `
      <p class="uxs-reply-overline">LA SEÑAL HA TERMINADO.</p>
      <h2>¿TIENES ALGO QUE DECIRLE?</h2>
      <p class="uxs-reply-anon">TU IDENTIDAD NO SE COMPARTE CON QUIEN LA RECIBE.</p>
      <button type="button" id="uxs-reply-yes">RESPONDER</button>
      <button type="button" id="uxs-reply-skip">CONTINUAR</button>`;

    const context = document.createElement("div");
    context.id = "uxs-reply-context";
    context.innerHTML = `<div class="uxs-reply-kicker">RESPONDIENDO A</div><div class="uxs-reply-question"></div>`;

    const composer = document.createElement("div");
    composer.id = "uxs-reply-composer";
    composer.innerHTML = `
      <h2>¿QUIERES ENVIAR TU RESPUESTA?</h2>
      <p class="uxs-reply-description">SOLO SE COMPARTIRÁ TU VOZ TRANSFORMADA, DESPUÉS DE REVISIÓN.</p>
      <div class="uxs-reply-actions">
        <button type="button" id="uxs-reply-send">ENVIAR RESPUESTA</button>
        <button type="button" id="uxs-reply-cancel">NO ENVIAR</button>
      </div>
      <p class="uxs-reply-privacy">AL ENVIAR, TU VOZ ORIGINAL SE UTILIZA TEMPORALMENTE PARA VERIFICAR TUS PALABRAS. SOLO SE CONSERVA TU VOZ TRANSFORMADA, PENDIENTE DE REVISIÓN.</p>
      <button type="button" id="uxs-reply-back-transcript">VOLVER</button>
      <p id="uxs-reply-feedback" role="status" aria-live="polite"></p>`;

    const ending = document.createElement("div");
    ending.id = "uxs-reply-end";
    ending.innerHTML = `<h2 id="uxs-reply-end-title"></h2><p id="uxs-reply-end-description"></p><button type="button" id="uxs-reply-outro">CONTINUAR</button>`;

    recording.append(choice, context, composer, ending);
    const yes = choice.querySelector("#uxs-reply-yes");
    const skip = choice.querySelector("#uxs-reply-skip");
    const send = composer.querySelector("#uxs-reply-send");
    const cancel = composer.querySelector("#uxs-reply-cancel");
    const feedback = composer.querySelector("#uxs-reply-feedback");
    const outroButton = ending.querySelector("#uxs-reply-outro");
    const backFromReply = composer.querySelector("#uxs-reply-back-transcript");

    let receivedId = null;
    let receivedQuestion = "";
    let mode = false;
    let completed = false;
    let submitting = false;
    let confirmedText = "";
    let mp3Ready = false;
    let supa = null;
    let outroStarted = false;
    // El outro se inicia solamente con una interacción del visitante.
    const PUBLIC_TEST = new URLSearchParams(location.search).get("uxs_outro_test") === "1";

    function removeShareStage() {
      if (!mode || completed) return;
      if (root.classList.contains("uxs-share-stage")) root.classList.remove("uxs-share-stage");
    }
    new MutationObserver(removeShareStage).observe(root, {attributes:true,attributeFilter:["class"]});

    function setReplyTitle() {
      const title = document.querySelector("#uxs-audio-interface .uxs-sound-title");
      if (title) title.textContent = "ESTE ES TU SONIDO.";
      const desc = document.querySelector("#uxs-audio-interface .uxs-sound-description");
      if (desc) desc.textContent = "ESCUCHA CÓMO SUENA TU RESPUESTA.";
      const signalLabel = document.querySelector("#uxs-sound-transformed .uxs-sound-label");
      if (signalLabel) signalLabel.textContent = "TU SEÑAL";
    }

    function updateComposer() {
      if (!mode || completed || root.dataset.uxsReviewStep !== "confirmed") return;
      removeShareStage();
      setReplyTitle();
      if (confirmedText && (mp3Ready || Boolean(window.UXSMP3?.getBlob?.()))) {
        mp3Ready = true;
        root.classList.add("uxs-reply-composing");
      }
    }

    // El outro se conecta SOLO cuando el recorrido ya terminó.
    // El botón permite iniciarlo mediante un toque en iOS/Android,
    // donde la reproducción automática con sonido puede bloquearse.
    function openOutro() {
      if (outroStarted) return;
      if (!window.UXSOutro || typeof window.UXSOutro.start !== "function") {
        console.error("UXS Reply V5: el archivo uxs-outro.js no está cargado.");
        ending.querySelector("#uxs-reply-end-description").textContent =
          "NO SE PUDO ABRIR EL FINAL. REVISA QUE UXS-OUTRO.JS ESTÉ CARGADO.";
        return;
      }
      outroStarted = true;
      preparePublicPlay();
      try {
        // La V23 detiene los otros elementos de audio antes de empezar.
        Promise.resolve(window.UXSOutro.start()).catch(error => {
          console.error("UXS Reply V5: error al iniciar el outro", error);
          outroStarted = false;
        });
      } catch (error) {
        console.error("UXS Reply V5: error al iniciar el outro", error);
        outroStarted = false;
      }
    }

    outroButton.addEventListener("click", openOutro);

    function finish(title, description) {
      if (completed) return;
      completed = true;
      choice.classList.remove("uxs-visible");
      root.classList.remove("uxs-incoming-stage", "uxs-reply-recording", "uxs-reply-composing", "uxs-share-stage", "uxs-audio-ready");
      root.classList.remove("uxs-reply-choice-stage");
      root.classList.add("uxs-reply-mode", "uxs-reply-finished");
      delete root.dataset.uxsReviewStep;
      document.getElementById("uxs-playback")?.pause();
      document.getElementById("uxs-vocoder-player")?.pause();
      document.getElementById("uxs-incoming-audio")?.pause();
      ending.querySelector("#uxs-reply-end-title").textContent = title;
      ending.querySelector("#uxs-reply-end-description").textContent = description;
      outroButton.disabled = false;
      outroButton.textContent = "CONTINUAR";

      // Sin temporizador: CONTINUAR inicia el outro con un gesto real.
      // Esto es más compatible con las restricciones de audio en móviles.
    }

    // Misma pantalla de sonido que en la primera grabación.
    // No cambia ni el código ni los eventos de la transcripción.
    function installReviewContinue() {
      const audioUI = document.getElementById("uxs-audio-interface");
      if (!audioUI || audioUI.querySelector("#uxs-review-continue")) return;
      const button = document.createElement("button");
      button.type = "button";
      button.id = "uxs-review-continue";
      button.textContent = "CONTINUAR";
      const again = audioUI.querySelector("#uxs-record-again");
      if (again) again.before(button);
      else audioUI.append(button);
      button.addEventListener("click", () => {
        if (root.dataset.uxsReviewStep !== "sound") return;
        const transcription = document.getElementById("uxs-transcription-panel");
        if (!transcription) {
          console.warn("UXS: la transcripción aún no está disponible.");
          return;
        }
        document.getElementById("uxs-playback")?.pause();
        document.getElementById("uxs-vocoder-player")?.pause();
        root.dataset.uxsReviewStep = "transcript";
        document.getElementById("uxs-main")?.scrollTo({top:0,behavior:"instant"});
      });
    }
    installReviewContinue();

    // Botón VOLVER de la transcripción al sonido, para ambos recorridos.
    // No se alteran la grabación ni los textos.
    function installReviewBack() {
      const panel = document.getElementById("uxs-transcription-panel");
      if (!panel || panel.querySelector("#uxs-review-back-sound")) return;
      const back = document.createElement("button");
      back.type = "button";
      back.id = "uxs-review-back-sound";
      back.textContent = "VOLVER A MI SONIDO";
      panel.append(back);
      back.addEventListener("click", () => {
        if (root.dataset.uxsReviewStep !== "transcript") return;
        root.dataset.uxsReviewStep = "sound";
        document.getElementById("uxs-main")?.scrollTo(0, 0);
      });
    }
    installReviewBack();

    // Volver desde la decisión final de RESPUESTA.
    // Se reabre el editor para permitir revisar/corregir, sin borrar texto.
    backFromReply.addEventListener("click", () => {
      if (submitting || completed || !mode) return;
      root.classList.remove("uxs-reply-composing");
      root.dataset.uxsReviewStep = "transcript";
      document.getElementById("uxs-transcription-panel")
        ?.classList.remove("uxs-confirmed");
      document.getElementById("uxs-main")?.scrollTo(0, 0);
    });

    // La primera señal también permite volver desde COMPARTIR.
    function installShareBack() {
      const share = document.getElementById("uxs-share-panel");
      if (!share || share.querySelector("#uxs-share-back-transcript")) return;
      const actions = share.querySelector(".uxs-share-actions");
      if (!actions) return;
      const back = document.createElement("button");
      back.type = "button";
      back.id = "uxs-share-back-transcript";
      back.textContent = "VOLVER";
      actions.insertAdjacentElement("afterend", back);
      back.addEventListener("click", () => {
        if (mode || completed) return;
        // No abandonar un envío en curso.
        if (share.querySelector("#uxs-share-yes")?.disabled) return;
        share.classList.remove("uxs-visible");
        root.classList.remove("uxs-share-stage");
        root.dataset.uxsReviewStep = "transcript";
        document.getElementById("uxs-transcription-panel")
          ?.classList.remove("uxs-confirmed");
        document.getElementById("uxs-main")?.scrollTo(0, 0);
      });
    }
    installShareBack();

    root.addEventListener("uxs:audio-ready", () => {
      root.dataset.uxsReviewStep = "sound";
      installReviewContinue();
      installReviewBack();
      installShareBack();
    });
    root.addEventListener("uxs:audio-cleared", () => {
      delete root.dataset.uxsReviewStep;
    });
    root.addEventListener("uxs:transcription-confirmed", () => {
      // El evento de confirmación es el que autoriza avanzar.
      root.dataset.uxsReviewStep = "confirmed";
    });

    if (PUBLIC_TEST) document.body.classList.add("uxs-outro-test-mode");
    else document.body.classList.remove("uxs-outro-test-mode");

    function addHumanNote() {
      const incoming = document.getElementById("uxs-incoming-panel");
      if (!incoming || document.getElementById("uxs-incoming-human-note")) return;
      const note = document.createElement("p");
      note.id = "uxs-incoming-human-note";
      note.textContent = "ESTA SEÑAL VIENE DE OTRO SER HUMANO.";
      const question = document.getElementById("uxs-incoming-question");
      if (question && incoming.contains(question)) question.before(note);
      else incoming.prepend(note);
    }
    addHumanNote();
    root.addEventListener("uxs:incoming-ready", addHumanNote);
    root.addEventListener("uxs:incoming-ended", addHumanNote);

    function preparePublicPlay() {
      const outro = document.getElementById("uxs-outro-v23");
      if (!outro || PUBLIC_TEST) return;
      let button = document.getElementById("uxs-outro-public-play");
      if (!button) {
        button = document.createElement("button");
        button.id = "uxs-outro-public-play";
        button.type = "button";
        button.textContent = "REPRODUCIR";
        outro.append(button);
      }
      const soundtrack = outro.querySelector("audio");
      if (!soundtrack || button.dataset.wired) return;
      button.dataset.wired = "1";
      const update = () => {
        const visible = outro.classList.contains("open") &&
          soundtrack.paused && !soundtrack.ended;
        button.classList.toggle("uxs-visible", visible);
      };
      button.addEventListener("click", () => {
        soundtrack.play().catch(error => console.warn("UXS Outro playback:", error));
      });
      soundtrack.addEventListener("play", update);
      soundtrack.addEventListener("pause", update);
      soundtrack.addEventListener("ended", () => button.classList.remove("uxs-visible"));
      const watcher = new MutationObserver(update);
      watcher.observe(outro, {attributes:true, attributeFilter:["class"]});
      update();
    }
    preparePublicPlay();

    root.addEventListener("uxs:incoming-ready", event => {
      if (!mode) receivedId = event.detail?.signalId || null;
    });
    root.addEventListener("uxs:incoming-ended", event => {
      if (mode || completed) return;
      receivedId = event.detail?.signalId || receivedId;
      receivedQuestion = document.getElementById("uxs-incoming-question")?.textContent?.trim() || "";
      if (receivedId) {
        root.classList.add("uxs-reply-choice-stage");
        choice.classList.add("uxs-visible");
      }
    });

    yes.addEventListener("click", () => {
      if (!receivedId || mode) return;
      mode = true;
      confirmedText = "";
      mp3Ready = false;
      choice.classList.remove("uxs-visible");
      root.classList.remove("uxs-reply-choice-stage");
      delete root.dataset.uxsReviewStep;
      context.querySelector(".uxs-reply-question").textContent = receivedQuestion;
      document.getElementById("uxs-incoming-audio")?.pause();
      root.classList.remove("uxs-incoming-stage", "uxs-share-stage", "uxs-audio-ready", "uxs-reply-finished");
      root.classList.add("uxs-reply-mode", "uxs-reply-recording");
      results.hidden = true;
      record.disabled = false;
      record.textContent = "HABLAR";
      // El botón del grabador utiliza el mismo MediaRecorder de 45 segundos.
      record.click();
    });

    skip.addEventListener("click", () => {
      if (mode || completed) return;
      mode = true;
      finish("TU CONEXIÓN TERMINA AQUÍ.", "GRACIAS POR ESCUCHAR.");
    });

    root.addEventListener("uxs:audio-cleared", () => {
      if (!mode || completed) return;
      confirmedText = "";
      mp3Ready = false;
      root.classList.remove("uxs-reply-composing");
      delete root.dataset.uxsReviewStep;
      feedback.textContent = "";
    });

    root.addEventListener("uxs:audio-ready", () => {
      if (!mode || completed) return;
      root.classList.remove("uxs-reply-recording");
      root.dataset.uxsReviewStep = "sound";
      // La transcripción conserva su lógica; la interfaz la oculta hasta CONTINUAR.
      setReplyTitle();
    });

    root.addEventListener("uxs:transcription-confirmed", event => {
      if (!mode || completed) return;
      confirmedText = String(event.detail?.text || "").trim();
      // uxs-mp3.js escucha este mismo evento; no lo interceptamos.
      queueMicrotask(updateComposer);
    });

    root.addEventListener("uxs:mp3-ready", () => {
      if (!mode || completed) return;
      mp3Ready = true;
      updateComposer();
    });

    // La pantalla de compartir V8 queda oculta y nunca usamos su botón.
    // Su estado visual se elimina sin bloquear sus otros eventos.
    root.addEventListener("uxs:recording-started", () => {
      if (!mode || completed) return;
      root.classList.add("uxs-reply-recording");
      root.classList.remove("uxs-reply-composing");
    });

    // Regrabación: se reutiliza el control ya probado de Interface Polish V5.
    root.addEventListener("click", event => {
      if (!mode || completed || submitting) return;
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest("#uxs-record-again")) return;
      confirmedText = "";
      mp3Ready = false;
      root.classList.remove("uxs-reply-composing");
      delete root.dataset.uxsReviewStep;
      root.classList.add("uxs-reply-recording");
    }, true);

    async function getClient() {
      if (!window.supabase?.createClient) throw new Error("SUPABASE_NOT_LOADED");
      if (!supa) {
        supa = window.supabase.createClient(SUPABASE_URL, SUPABASE_KEY, {
          auth: {persistSession:true,autoRefreshToken:true,detectSessionInUrl:false}
        });
      }
      const {data, error} = await supa.auth.getSession();
      if (error) throw error;
      if (!data.session?.access_token) {
        const login = await supa.auth.signInAnonymously();
        if (login.error) throw login.error;
      }
      return supa;
    }

    async function originalAudio() {
      const source = document.getElementById("uxs-playback")?.getAttribute("src");
      if (!source) throw new Error("ORIGINAL_AUDIO_MISSING");
      const response = await fetch(source);
      if (!response.ok) throw new Error("ORIGINAL_AUDIO_UNAVAILABLE");
      const blob = await response.blob();
      const mime = blob.type.split(";")[0].toLowerCase();
      const extensions = {
        "audio/webm":"webm", "video/webm":"webm", "audio/mp4":"mp4",
        "video/mp4":"mp4", "audio/wav":"wav", "audio/x-wav":"wav",
        "audio/mpeg":"mp3", "audio/ogg":"ogg"
      };
      if (!extensions[mime]) throw new Error("UNSUPPORTED_ORIGINAL_AUDIO");
      return {blob, name:`uxs-original.${extensions[mime]}`};
    }

    async function submitReply() {
      if (submitting || completed || !mode || !receivedId) return;
      const mp3 = window.UXSMP3?.getBlob?.();
      if (!confirmedText || !mp3) {
        feedback.textContent = "ESPERA A CONFIRMAR TUS PALABRAS Y PREPARAR TU SEÑAL.";
        return;
      }
      submitting = true;
      send.disabled = true;
      cancel.disabled = true;
      feedback.textContent = "VERIFICANDO Y ENVIANDO TU RESPUESTA...";
      try {
        const original = await originalAudio();
        const client = await getClient();
        const form = new FormData();
        form.append("signal_id", receivedId);
        form.append("audio", mp3, "uxs-reply.mp3");
        form.append("original_audio", original.blob, original.name);
        form.append("transcript", confirmedText);
        form.append("consent", "true");
        const {data, error} = await client.functions.invoke("uxs-save-reply", {body:form});
        if (error || !data?.success) {
          let code = data?.error || "REPLY_SAVE_FAILED";
          try {
            const body = await error?.context?.clone?.().json();
            code = body?.error || code;
          } catch (_) {}
          if (code === "SIGNAL_ALREADY_ANSWERED") {
            finish("ESTA SEÑAL YA RECIBIÓ UNA RESPUESTA.", "TU GRABACIÓN NO SE COMPARTIÓ.");
            return;
          }
          throw new Error(code);
        }
        finish("TU RESPUESTA FUE RECIBIDA.", "SE GUARDÓ DE FORMA PRIVADA Y ESTÁ PENDIENTE DE REVISIÓN.");
      } catch (error) {
        console.error("UXS Reply V5:", error);
        feedback.textContent = "NO PUDIMOS CONFIRMAR EL ENVÍO. REVISA SUPABASE ANTES DE REINTENTAR PARA EVITAR DUPLICADOS.";
      } finally {
        submitting = false;
        send.disabled = false;
        cancel.disabled = false;
      }
    }

    send.addEventListener("click", submitReply);
    cancel.addEventListener("click", () => {
      if (submitting || completed) return;
      finish("TU RESPUESTA SE QUEDA CONTIGO.", "GRACIAS POR ESCUCHAR.");
    });

    console.log("UXS Reply V5 + Outro V23 Ready");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
